export default __webpack_public_path__ + "assets/images/error.dcbf0c.webp";